import Box from "@mui/material/Box";
import React, {useEffect} from "react";
import {usePageContext} from "../../context/PageContext";
import {
    easyLangTopNaviStyle,
    pageGridItemFullWidthSx,
    placement_header,
    placement_topnavi
} from "./pageLayoutsUtils";
import useNavigationHeight from "../../utility/useNavigationHeight";
import useWindowSize from "../../utility/useWindowSize";

import type {CAEGlobalSettings} from "../../types/CAEGlobalSettings";
import {PageGridPlacementType} from "../types";
import {getPageContent, renderFooter, renderPlacements, renderStandardContent} from "./HomepageLayout";
import EasyLangNavigation from "../layouts/navigation/EasyLangNavigation";
import TopNavi from "../layouts/topnavi/TopNavi";

interface Props {
    isHideNavi?: boolean,
    navigation: any,
    page: any,
    content?: any,
    CAEGlobalSettings: CAEGlobalSettings,
    children?: JSX.Element,
    currentURL: string,
    csrfToken: string,
    pageSettings?: any,
    credentials?: any,
    donationInitializerData?: { queryData: any; isProduct: boolean; contentId: string } | null
}

function EasyLangLayout(props: Props) {
    const pageContext = usePageContext();
    const {greaterThanWindowLarge} = useWindowSize();
    const navHeight = useNavigationHeight(props.isHideNavi || pageContext.hideTopNavi);
    const header = props.page?.grid.placements.find((p: PageGridPlacementType) => p.name === placement_header);

    // Set a dynamic scroll padding so that the scroll target is not below the header
    useEffect(() => {
        if (!document || navHeight === undefined) return;
        document.body.style.scrollPaddingTop = navHeight;
        document.documentElement.style.scrollPaddingTop = navHeight;
    }, [navHeight]);

    const pageContentType = getPageContent(props);

    return (
        <React.Fragment key={placement_topnavi}>
            <EasyLangNavigation navigation={props.navigation} header={header}
                                page={props.page}
                                topNavi={
                                    greaterThanWindowLarge && <TopNavi empty={props.isHideNavi}
                                                                       navigation={props.navigation}
                                                                       page={props.page}
                                                                       topNaviStyle={easyLangTopNaviStyle}
                                                                       header={props.page?.grid.placements.find((p: PageGridPlacementType) => p.name === placement_header)}/>
                                }/>
            <Box
                component='main'
                id='grid'
                sx={pageGridItemFullWidthSx}>
                {
                    renderStandardContent(props, props.isHideNavi, true)
                }
                {
                    renderPlacements(props, pageContentType)
                }
            </Box>
            {renderFooter(props, true)}
        </React.Fragment>
    );
}

export default EasyLangLayout